import React from "react";

export default (props) => (
    <span className="sportroute__rating__total">
        (Gemiddelde van {props.count} reviews)
    </span>
)